import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { defaultDoc } from '../share/defaultDoc';

export interface SignAndStampUserConsent {
  readonly userConsentData: string;
  readonly pk_UserSignAndStampConsentData: string;
  readonly isActive: boolean;
  readonly dateCreated: string;
  readonly dateModified?: string;
  readonly createdBy?: string;
  readonly modifiedBy?: string;
}

export const signAndStampUserConsentSchema: RxJsonSchema<SignAndStampUserConsent> = {
  type: 'object',
  version: 0,
  description: 'describes sign and stamp user consent data',
  primaryKey: 'pk_UserSignAndStampConsentData',
  properties: {
    pk_UserSignAndStampConsentData: { type: 'string', maxLength: 36 },
    userConsentData: { type: ['string', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    createdBy: { type: ['string', 'null'] },
    modifiedBy: { type: ['string', 'null'] },
  },
};

export type SignAndStampUserConsentFileCollection = RxCollection<SignAndStampUserConsent> | null;
export type SignAndStampUserConsentFileDocument = RxDocument<SignAndStampUserConsent>;

export const signAndStampUserConsentPullQueryBuilder = (document: SignAndStampUserConsent) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query userSignAndStampConsentData($lastRequested: DateTime!) {
      userSignAndStampConsentData(lastRequested: $lastRequested) {
        pk_UserSignAndStampConsentData
        userConsentData
        isActive
        createdBy
        dateCreated
        dateModified
        modifiedBy
      }
    }
  `);
  return {
    query,
    variables: {
      lastRequested: doc?.dateModified ? doc?.dateModified : doc?.dateCreated,
    },
  };
};

export default {};
